import { createStore } from 'redux';
import rootReducer from './RootReducer';

// const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(logger, thunk)));
const store = createStore(rootReducer);

export default store;
